import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
export function CountdownBanner() {
  const [timeLeft, setTimeLeft] = useState(420); // 7 minutes in seconds
  useEffect(() => {
    if (timeLeft <= 0) return;
    const timerId = setInterval(() => {
      setTimeLeft(prev => prev - 1);
    }, 1000);
    return () => clearInterval(timerId);
  }, [timeLeft]);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  const formattedTime = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  const scrollToPricing = () => {
    document.getElementById('final-cta')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <div className="fixed bottom-0 left-0 right-0 md:relative md:w-full bg-gradient-to-r from-[#0A0A0A] via-[#1A1A1A] to-[#0A0A0A] border-t md:border-b border-[#D4AF37]/30 py-2 md:py-3 px-3 md:px-4 z-50 shadow-[0_0_20px_rgba(212,175,55,0.15)]" data-id="element-199">
      <div className="max-w-7xl mx-auto flex flex-row items-center justify-between md:justify-center gap-2 md:gap-6 text-center" data-id="element-200">
        <span className="text-[#E8E0D0] font-bold text-xs md:text-base uppercase tracking-wide hidden md:inline" data-id="element-201">
          🔥 ¡OFERTA ESPECIAL! Esta oferta se termina en:
        </span>

        {/* Mobile compact version */}
        <span className="text-[#E8E0D0] font-semibold text-xs uppercase tracking-wide md:hidden" data-id="element-202">
          🔥 Oferta termina en:
        </span>

        <motion.div animate={{
        opacity: [1, 0.7, 1]
      }} transition={{
        duration: 1,
        repeat: Infinity,
        ease: 'easeInOut'
      }} className="text-[#D4AF37] font-black text-lg md:text-3xl tracking-wider drop-shadow-[0_0_10px_rgba(212,175,55,0.5)]" data-id="element-203">
          {timeLeft > 0 ? formattedTime : '00:00'}
        </motion.div>

        <button onClick={scrollToPricing} className="text-[#D4AF37] font-bold text-xs md:text-base hover:text-[#B8962E] transition-colors flex items-center gap-1 uppercase tracking-wide" data-id="element-204">
          <span className="hidden md:inline" data-id="element-205">¡Compra ahora!</span>
          <span className="md:hidden" data-id="element-206">¡Compra!</span>
          <span aria-hidden="true" data-id="element-207">&rarr;</span>
        </button>
      </div>
    </div>;
}